module.exports = __webpack_public_path__ + "static/media/Circle-Plus_Black.600a5f6a.svg";